import { Suspense, useContext } from "react";

import { AbilityContext } from "@context/can";
import { ComponentSpinner } from "@components/spinner";
import { Navigate } from "react-router-dom";
import { UserContext } from "@context/user";
import { getPanelDefaultRoute } from "./routes";
import { getItemFromStore } from "../utility/helpers/utils";
import size from "lodash/size";

const PrivateRoute = ({ children, route }) => {
  // ** Hooks & Vars
  const ability = useContext(AbilityContext);
  const { opsPaymentModel } = useContext(UserContext);
  const userInfo = getItemFromStore("userInfo") || {};

  if (route) {
    let resource = null;
    let action = "";
    const title = "Demo";
    if (route.meta) {
      resource = route.meta.resource;
      action = route.meta.action || "null";
    }
    if (!size(userInfo.user)) {
      return <Navigate to="/login" />;
    }

    if (ability.cannot(action, resource) && size(userInfo.user)) {
      return <Navigate to={getPanelDefaultRoute()} />;
    }

    // A page that only exists for one payment model is off-limits while the Ops
    // topbar toggle sits on the other one — hiding the nav entry isn't enough,
    // a hand-typed URL has to bounce too.
    if (route.meta?.paymentModel && route.meta.paymentModel !== opsPaymentModel) {
      return <Navigate to={getPanelDefaultRoute()} />;
    }

    document.title = route.meta.title || title;
  }

  return (
    <Suspense fallback={<ComponentSpinner className="mt-5 pt-5" />}>
      {children}
    </Suspense>
  );
};

export default PrivateRoute;
